import PropTypes from "prop-types";
import React from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { format } from "date-fns";

const EmployeeInformationDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Employee Information</h4>
      </div>
      <div className="view-employee-content">
        <ul className="">
          <li>
            <h4>Unique ID</h4>
            <h6>{employee?.uniqueId}</h6>
          </li>
          {employee?.employeeType !== "3" && (
            <li>
              <h4>IC Number</h4>
              <h6>{employee?.icno}</h6>
            </li>
          )}
          {employee?.employeeType === "3" && (
            <li>
              <h4>Fin Number</h4>
              <h6>{employee?.finNumber}</h6>
            </li>
          )}

          <li>
            <h4>Location Code</h4>
            <h6>{employee?.locationCode}</h6>
          </li>

          <li>
            <h4>Department</h4>
            <h6>{employee?.departmentname}</h6>
          </li>
          <li>
            <h4>Designation</h4>
            <h6>{employee?.designationName}</h6>
          </li>
          <li>
            <h4>Is Supervisor</h4>
            <h6>{employee?.isSupervisor ? "Yes" : "No"}</h6>
          </li>
          <li>
            <h4>Job Title</h4>
            <h6>{employee?.jobTitle}</h6>
          </li>
          <li>
            <h4>Comfirmation Date</h4>
            <h6>
              {(employee?.confirmationDate && employee?.confirmationDate) || ""}
              {/* {(employee?.confirmationDate &&
                format(new Date(employee?.confirmationDate), "dd-MM-yyyy")) ||
                ""} */}
            </h6>
          </li>
          <li>
            <h4>Join Date</h4>
            <h6>
              {(employee?.joinDate && employee?.joinDate) || ""}
              {/* {(employee?.joinDate &&
                format(new Date(employee?.joinDate), "dd-MM-yyyy")) ||
                ""} */}
            </h6>
          </li>

          <li>
            <h4>Working Status</h4>
            <h6>
              {employee?.employmentStatus === 1
                ? "Working"
                : employee?.employmentStatus === 2
                ? "Termineted"
                : employee?.employmentStatus === 3
                ? "Transfered"
                : ""}
            </h6>
          </li>
          <li>
            <h4>Employee Type</h4>
            <h6>{employee?.employeeTypeName}</h6>
          </li>
          <li>
            <h4>Skilled Employee</h4>
            <h6>{employee?.skilledOrUnSkilled === "S" ? "Yes" : "No"}</h6>
          </li>

          <li>
            <h4>No Of Working Houres Per Day</h4>
            <h6>{employee?.workingHoursPerDay}</h6>
          </li>
          {/* <li>
            <h4>No Of Working Days Per Week</h4>
            <h6>{employee?.noofworkingDaysPerWeek}</h6>
          </li> */}
          <li>
            <h4>Residential Type</h4>
            <h6>{employee?.residentialType}</h6>
          </li>
          <li>
            <h4>PR CPF Type</h4>
            <h6>
              {employee?.prcpfType === "G"
                ? "Graduate"
                : employee?.prcpfType === "F"
                ? "Full"
                : ""}
            </h6>
          </li>
        </ul>
      </div>
    </div>
  );
};

EmployeeInformationDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default EmployeeInformationDetails;
